function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIluvitLogo24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "18px",
    viewBox: "0 0 23 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(65.882353%,56.078431%,56.078431%)",
      fillOpacity: 1
    },
    d: "M 22.984375 14.746094 C 22.984375 16.527344 21.59375 17.972656 19.878906 17.972656 C 18.160156 17.972656 16.769531 16.527344 16.769531 14.746094 C 16.769531 12.964844 18.160156 11.519531 19.878906 11.519531 C 21.59375 11.519531 22.984375 12.964844 22.984375 14.746094 Z M 22.984375 14.746094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.764706%,61.568627%,61.568627%)",
      fillOpacity: 1
    },
    d: "M 0 10.648438 C 0 8.867188 1.390625 7.425781 3.109375 7.425781 C 4.824219 7.425781 6.214844 8.867188 6.214844 10.648438 L 6.214844 14.746094 C 6.214844 16.527344 4.824219 17.972656 3.109375 17.972656 C 1.390625 17.972656 0 16.527344 0 14.746094 Z M 0 10.648438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.764706%,61.568627%,61.568627%)",
      fillOpacity: 1
    },
    d: "M 10.257812 0 C 8.542969 0 7.152344 1.445312 7.152344 3.226562 L 7.152344 14.746094 C 7.152344 14.75 7.152344 14.75 7.152344 14.753906 C 7.148438 15.683594 7.535156 16.609375 8.277344 17.246094 C 9.601562 18.382812 11.558594 18.191406 12.652344 16.820312 L 22.285156 5.292969 C 23.378906 3.917969 23.195312 1.886719 21.875 0.75 C 20.550781 -0.386719 18.59375 -0.195312 17.5 1.175781 L 13.367188 6.121094 L 13.367188 3.226562 C 13.367188 1.445312 11.976562 0 10.257812 0 Z M 10.257812 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(65.882353%,56.078431%,56.078431%)",
      fillOpacity: 1
    },
    d: "M 6.214844 3.226562 C 6.214844 5.007812 4.824219 6.453125 3.109375 6.453125 C 1.390625 6.453125 0 5.007812 0 3.226562 C 0 1.445312 1.390625 0 3.109375 0 C 4.824219 0 6.214844 1.445312 6.214844 3.226562 Z M 6.214844 3.226562 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIluvitLogo24);
export default __webpack_public_path__ + "static/media/iluvit_logo_24.33e50b3fffffd065531d60bb344ae1a5.svg";
export { ForwardRef as ReactComponent };